/* eslint-disable no-multi-assign */
/** eslint-disable */
const nextRoutes = require('next-routes');

const routes = (module.exports = nextRoutes());

routes.add('/company-detail/:id', 'company-detail');
routes.add('/employee-details/:id', 'employee-details');
routes.add('/restaurants-detail/:id', 'restaurants-detail');
routes.add('/refunds-detail/:id', 'refunds-detail');
routes.add('/users-detail/:id', 'users-detail');
routes.add('/credits-affection-employee/:id', '/credits-affection-employee');
routes.add('/island/:id', 'island');

routes.add('/create-employee/:id', 'create-employee');
// routes.add('/bo-history', 'audit/user');

routes.add('/payment-tracking', 'payment-tracking');

// Suivi comptable
routes.add('/accounting', 'accounting');

// GROUP USER
routes.add('/restaurants-groups', 'restaurants-groups');
routes.add('/restaurants-groups-create', 'restaurants-groups-create');
routes.add('/restaurants-groups-detail/:id', 'restaurants-groups-detail');
